import { useEffect, useRef } from 'react';

export const DownloadCSV = ({
  filename,
  data,
  onFinish,
}: {
  filename: string;
  data: string;
  onFinish?: () => void;
}) => {
  const inputRef = useRef<HTMLAnchorElement>(null);
  const downloaded = useRef(false);

  useEffect(() => {
    if (!downloaded.current) {
      downloaded.current = true;
      inputRef.current?.click();
      onFinish && setTimeout(onFinish, 0);
    }
  }, [onFinish]);

  return <a ref={inputRef} href={encodeURI(data)} download={filename} />;
};
